import { render } from "./소화기내과.vue?vue&type=template&id=13a6a934"
import script from "./소화기내과.vue?vue&type=script&lang=js"
export * from "./소화기내과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__